var checkforPricingPage = document.querySelector('.card-radio-btn');
if (checkforPricingPage) {
    document.querySelectorAll('.card-radio-btn label').forEach(label => {
        label.addEventListener('click', (e) => {
            var clickedID = label.querySelector('input').id;
            /* Need to optimize later... */
            switch(clickedID) {
                case 'tp-year':
                    document.querySelector('p[data-price="tp-year"]').classList.add('active');
                    document.querySelector('p[data-price="tp-month"]').classList.remove('active');
                    document.querySelector('#btn-tp-y').classList.add('active');
                    document.querySelector('#btn-tp-m').classList.remove('active');
                    break;
                case 'tp-month':
                    document.querySelector('p[data-price="tp-year"]').classList.remove('active');
                    document.querySelector('p[data-price="tp-month"]').classList.add('active');
                    document.querySelector('#btn-tp-y').classList.remove('active');
                    document.querySelector('#btn-tp-m').classList.add('active');
                    break;
                case 'me-year':
                    document.querySelector('p[data-price="me-year"]').classList.add('active');
                    document.querySelector('p[data-price="me-month"]').classList.remove('active');
                    document.querySelector('#btn-me-y').classList.add('active');
                    document.querySelector('#btn-me-m').classList.remove('active');
                    break;
                case 'me-month':
                    document.querySelector('p[data-price="me-year"]').classList.remove('active');
                    document.querySelector('p[data-price="me-month"]').classList.add('active');
                    document.querySelector('#btn-me-y').classList.remove('active');
                    document.querySelector('#btn-me-m').classList.add('active');
                    break;
                case 'gde-year':
                    document.querySelector('p[data-price="gde-year"]').classList.add('active');
                    document.querySelector('p[data-price="gde-month"]').classList.remove('active');
                    document.querySelector('#btn-gde-y').classList.add('active');
                    document.querySelector('#btn-gde-m').classList.remove('active');
                    break;
                case 'gde-month':
                    document.querySelector('p[data-price="gde-year"]').classList.remove('active');
                    document.querySelector('p[data-price="gde-month"]').classList.add('active');
                    document.querySelector('#btn-gde-y').classList.remove('active');
                    document.querySelector('#btn-gde-m').classList.add('active');
                    break;
                case 'abe-year':
                    document.querySelector('p[data-price="abe-year"]').classList.add('active');
                    document.querySelector('p[data-price="abe-month"]').classList.remove('active');
                    document.querySelector('#btn-abe-y').classList.add('active');
                    document.querySelector('#btn-abe-m').classList.remove('active');
                    break;
                case 'abe-month':
                    document.querySelector('p[data-price="abe-year"]').classList.remove('active');
                    document.querySelector('p[data-price="abe-month"]').classList.add('active');
                    document.querySelector('#btn-abe-y').classList.remove('active');
                    document.querySelector('#btn-abe-m').classList.add('active');
                    break;
                case 'nfe-year':
                    document.querySelector('p[data-price="nfe-year"]').classList.add('active');
                    document.querySelector('p[data-price="nfe-month"]').classList.remove('active');
                    document.querySelector('#btn-nfe-y').classList.add('active');
                    document.querySelector('#btn-nfe-m').classList.remove('active');
                    break;
                case 'nfe-month':
                    document.querySelector('p[data-price="nfe-year"]').classList.remove('active');
                    document.querySelector('p[data-price="nfe-month"]').classList.add('active');
                    document.querySelector('#btn-nfe-y').classList.remove('active');
                    document.querySelector('#btn-nfe-m').classList.add('active');
                    break;
            }
            //document.querySelector('p[data-price="'+clickedID+'"]').classList.add('active');
        });
    });

    document.querySelector('.scrolldown-ext').onclick = function(e){
        e.preventDefault();
        const id = 'extensions';
        const yOffset = -110;
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    };
}